import React from "react"
import { Checkbox } from "@material-ui/core"
import { PickerListItem } from "."

const CheckboxPickerListItem = ({ item, checked, onChange, children, disabled, cy, inputProps, ...props }) => (
  <PickerListItem style={{ opacity: disabled ? "0.3" : "1" }} data-cy={cy} {...props}>
    {onChange && (
      <Checkbox
        color="primary"
        checked={checked}
        onChange={(e) => onChange(e, item)}
        disabled={!!disabled}
        inputProps={inputProps}
      />
    )}
    {children}
  </PickerListItem>
)

export { CheckboxPickerListItem }
